import {
  BADGE_VALUES,
  ElementUIState,
} from '../../Controllers/UIController/UITypes';
import { TutorialModule } from './TutorialModule';
import { t } from 'i18next';

export class MineButton extends TutorialModule {
  id = 'MineButton' as 'MineButton';

  onAction = (id?: string) => {
    this.app.ui.tooltip.hide();
    if (id === 'mine') {
      this.onComplete();
    }
  };

  execute = async () => {
    this.app.ui.setTutorialUIState({
      badges: {
        mine: 0,
        earn: 0,
        friends: 0,
        boosters: 0,
        trading: BADGE_VALUES.TRADING_ALERT,
      },
    });

    this.app.ui.setClickerUIState({
      btnClicker: ElementUIState.Normal,
      btnLeague: ElementUIState.Inactive,

      footer: ElementUIState.Normal,

      btnFriends: ElementUIState.Normal,
      btnMine: ElementUIState.Highlight,
      btnEarn: ElementUIState.Mystery,
      btnBooster: ElementUIState.Normal,
      btnTeam: ElementUIState.Hidden,
    });

    this.app.tutorial.showTooltip({
      text: t('tut_tooltip_earnwhileyouwait'),
      origin: { x: '50%', y: '100%' },
      offset: { x: '8px', y: '-185px' },
      align: 'bottom',
    });

    return super.execute().then(() => {
      this.app.ui.tooltip.hide();
    });
  };

  getAnalyticsOpts() {
    return {
      key: 'FTUE_mine_press_mine_button',
    };
  }
}
